import { type ModalKey } from "../modal/modalConfig";

export type Actor = "customer" | "lab" | "both";

export type Stage = {
  id: string;
  n: string; // circled number glyph
  name: string;
  actor: Actor;
  action: string;
  services: ModalKey[];
};

// The 6-stage order lifecycle loop (CONTEXT §4). Copy ported from the legacy
// ASCII diagram + the CONTEXT brief.
export const STAGES: Stage[] = [
  {
    id: "intake",
    n: "①",
    name: "INTAKE",
    actor: "both",
    action:
      "Customer drops in the dropbox / mails in and fills the drop form; the lab prints a return label if requested + creates a draft invoice.",
    services: ["drop"],
  },
  {
    id: "process",
    n: "②",
    name: "PROCESS",
    actor: "lab",
    action:
      "The lab manages the queue in all-orders, scans the film, and one-click preps + uploads zip + thumbnails to R2 via the order_up scripts.",
    services: ["allorders"],
  },
  {
    id: "progress",
    n: "③",
    name: "IN PROGRESS",
    actor: "customer",
    action: "Customer checks status on turnaround.",
    services: ["turnaround"],
  },
  {
    id: "pay",
    n: "④",
    name: "READY → PAY",
    actor: "both",
    action:
      "The lab one-click finalizes in invoices → payment email (email-dispatcher); the customer pays on the pay page.",
    services: ["invoices", "pay"],
  },
  {
    id: "deliver",
    n: "⑤",
    name: "DELIVER",
    actor: "customer",
    action:
      "Customer is redirected to downloads; files stream from R2 — a one-off gallery, or a club-member gallery (negativ).",
    services: ["downloads", "negativ"],
  },
  {
    id: "pickup",
    n: "⑥",
    name: "PICKUP",
    actor: "both",
    action:
      "Customer books a pickup on unified-pickup; the lab confirms + hands over the negatives.",
    services: ["pickups"],
  },
];

export const RETURN_LABEL = "↺ 40% of all-time customers return 3+ times";

// Actor accent (DESIGN.md: customer=cyan, lab=amber, both=green "handshake").
export const ACTOR_COLOR: Record<Actor, string> = {
  customer: "var(--cyan)",
  lab: "var(--amber)",
  both: "var(--green)",
};

export const ACTOR_LABEL: Record<Actor, string> = {
  customer: "customer",
  lab: "the lab",
  both: "customer + lab",
};
